import UserApi from '@web/api/modules/User'
import {
  AuthState,
  AuthGettersTree,
  AuthMutationsTree,
  AuthActionsTree
} from '../types/modules/auth'

const state: AuthState = {
  email: '',
  emailStatus: 'code',
  phone: '',
  phoneStatus: 'phone',
  needStartTimer: false,
  timerSeconds: 0,
  isTimerActive: false
}

const getters: AuthGettersTree = {
  email: ({ email }) => email,
  emailStatus: ({ emailStatus }) => emailStatus,
  phone: ({ phone }) => phone,
  phoneStatus: ({ phoneStatus }) => phoneStatus,
  needStartTimer: ({ needStartTimer }) => needStartTimer,
  timerSeconds: ({ timerSeconds }) => timerSeconds,
  isTimerActive: ({ isTimerActive }) => isTimerActive
}

const mutations: AuthMutationsTree = {
  setEmail (state, email) {
    state.email = email
  },
  setEmailStatus (state, emailStatus) {
    state.emailStatus = emailStatus
  },
  setPhone (state, phone) {
    state.phone = phone
  },
  setPhoneStatus (state, phoneStatus) {
    state.phoneStatus = phoneStatus
  },
  setNeedStartTimer (state, needStartTimer) {
    state.needStartTimer = needStartTimer
  },
  setTimerSeconds (state, timerSeconds) {
    state.timerSeconds = timerSeconds
  },
  setIsTimerActive (state, isTimerActive) {
    state.isTimerActive = isTimerActive
  },
  setField (state, { key, value }) {
    state[key] = value
  },
  reset (state) {
    state.email = ''
    state.emailStatus = 'email'
    state.phone = ''
    state.phoneStatus = 'phone'
    state.needStartTimer = false
    state.timerSeconds = 0
    state.isTimerActive = false
  }
}

let timerInterval: number | null = null

/* istanbul ignore next */
const actions: AuthActionsTree = {
  requestEmailCode ({ commit }, email) {
    return UserApi.requestEmailCode(email).then(() => {
      commit('setNeedStartTimer', true)
    })
  },
  verifyEmailCode ({ commit }, { email, code }) {
    return UserApi.verifyEmailCode({ email, code })
      .then(({ data: user }) => {
        commit('user/setUser', user, { root: true })
      })
  },
  requestPhoneCode ({ commit }, phone) {
    return UserApi.requestPhoneCode(phone)
  },
  verifyPhoneCode ({ commit }, { phone, code }) {
    return UserApi.verifyPhoneCode({ phone, code })
      .then(() => {
        commit('user/setField', { key: 'requirePhoneValidate', value: false }, { root: true })
        commit('user/setField', { key: 'phoneValidated', value: true }, { root: true })
        commit('user/setField', { key: 'phone', value: phone }, { root: true })
      })
  },
  supressPhoneValidation ({ commit }) {
    return UserApi.supressPhoneValidation()
  },
  startTimer ({ commit }, seconds) {
    // Останавливаем предыдущий таймер, если он был запущен
    if (timerInterval) {
      clearInterval(timerInterval)
    }

    commit('setTimerSeconds', seconds)
    commit('setIsTimerActive', true)

    timerInterval = setInterval(() => {
      commit('setTimerSeconds', Math.max(0, seconds - 1))
      seconds--

      if (seconds <= 0) {
        commit('setIsTimerActive', false)
        if (timerInterval) {
          clearInterval(timerInterval)
          timerInterval = null
        }
      }
    }, 1000)
  },
  stopTimer ({ commit }) {
    if (timerInterval) {
      clearInterval(timerInterval)
      timerInterval = null
    }
    commit('setIsTimerActive', false)
  },
  resetTimer ({ commit }) {
    if (timerInterval) {
      clearInterval(timerInterval)
      timerInterval = null
    }
    commit('setTimerSeconds', 0)
    commit('setIsTimerActive', false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
// eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any
